import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaTimes } from "react-icons/fa";
import image1 from "../assets/l20.png";
import image2 from "../assets/l19.png";
import image3 from "../assets/land1.png";
import image10 from "../assets/land4.png";
import image4 from "../assets/land3.png";
import image5 from "../assets/land2.png";
import image6 from "../assets/l16.png";
import image7 from "../assets/land5.png";
import image8 from "../assets/l14.png";
import image9 from "../assets/l15.png";



const Banner = () => {
  const [zoomedImage, setZoomedImage] = useState(null);

  const handleZoomIn = (imageSrc) => {
    setZoomedImage(imageSrc);
  };

  const handleZoomOut = () => {
    setZoomedImage(null);
  };
  return (
    <div className="elementor-widget-container">
      <div className="banner-area auto-height text-color bg-gray inc-shape">
        <div className="item">
          <div className="container">
            <div className="row align-center">
              {/* Text Content */}
              <div className="col-lg-6 col-sm-12 col-md-6 col-xl-6">
                <div className="content">
                  
                  <h2 className="wow fadeInDown" style={{ visibility: "visible", animationName: "fadeInDown" }}>
                  Brand Like a Boss in 5 Minutes
                  </h2>
                  <h3 className="tagline">
                  <strong style={{fontSize:'50px',fontWeight:'800',color:'#2e3192'}}>AI Is Your New Team</strong>
                  </h3>
                  <p className="wow fadeInLeft" style={{ visibility: "visible", animationName: "fadeInLeft" }}>
                  Create impactful content with AI-driven post generation, schedule Knack Moments for special occasions, share Knack Feeds for daily updates, automate posting with smart scheduling, and never miss a beat with email alerts—all from one intuitive platform.
                  </p>
                  <div className="banner-buttons">
                    <Link to="/Login">
                      <a className="btn circle btn-theme effect btn-md wow fadeInUp me-3" href="#" style={{ visibility: "visible", animationName: "fadeInUp" }}>
                        Start Now <i className=""></i>
                      </a>
                    </Link>
                    {/* <Link to="/onboarding">
                      <a className="btn circle btn-outline-theme effect btn-md wow fadeInUp me-3" href="#" style={{ visibility: "visible", animationName: "fadeInUp" }}>
                        Get Started <i className=""></i>
                      </a>
                    </Link> */}
                  </div>
                </div>
              </div>

              {/* Image */}
              <div className="col-lg-6 col-sm-12 col-md-6 col-xl-6">
              <div id="carouselWithCaptions" className="carousel slide" data-bs-ride="carousel" style={{ position: 'relative', overflow: 'visible' }}>
  <div className="carousel-inner">
    {/* login */}
    <div className="carousel-item active">
      <div>
        <img
          src={image1}
          className="img-fluid"
          alt="Slide 1"
          onClick={() => handleZoomIn(image1)}
          style={{ objectFit: "contain", height:'300px',width:'600px',marginTop:'50px',marginBottom:'120px', cursor: 'pointer'}}
        />
        <div className="carousel-caption d-none d-md-block">
          <p style={{ fontSize: '15px', color: '#2e3192' }}>
          Automate your content. Engage your audience. Grow your brand - powered by KnackVibes.
            
          </p>
        </div>
      </div>
    </div>

    {/* profile Hub */}
    <div className="carousel-item">
      <img
        src={image2}
        className="img-fluid"
        alt="Slide 2"
        onClick={() => handleZoomIn(image2)}
        style={{ objectFit: "contain", height:'300px',width:'600px',marginTop:'50px',marginBottom:'120px', cursor: 'pointer'}}
      />
      <div className="carousel-caption d-none d-md-block">
        <p style={{ fontSize: '15px', color: '#2e3192' }}>
        Secure login tailored for your branding role - Personal, Business, or Agency.
          {/* Customize your profile, prompts, and interests with powerful AI-driven tools. */}
        </p>
      </div>
    </div>

    {/* post tool */}
    <div className="carousel-item">
      <img
        src={image3}
        className="img-fluid"
        alt="Slide 3"
        onClick={() => handleZoomIn(image3)}
        style={{ objectFit: "contain", height:'300px',width:'600px',marginTop:'50px',marginBottom:'120px', cursor: 'pointer'}}
      />
      <div className="carousel-caption d-none d-md-block">
        <p style={{ fontSize: '15px', color: '#2e3192' }}>
        Your entire content workflow in one smart dashboard.
        Plan, track, and elevate every post with clarity.
        </p>
      </div>
    </div>
    <div className="carousel-item">
      <img
        src={image10}
        className="img-fluid"
        alt="Slide 3"
        onClick={() => handleZoomIn(image10)}
        style={{ objectFit: "contain", height:'300px',width:'600px',marginTop:'50px',marginBottom:'120px', cursor: 'pointer'}}
      />
      <div className="carousel-caption d-none d-md-block">
        <p style={{ fontSize: '15px', color: '#2e3192' }}>
        Create meaningful content effortlessly.
        Share your ideas, posts, and polls with impact.
        </p>
      </div>
    </div>

    {/* schedule post */}
    <div className="carousel-item">
      <img
        src={image4}
        className="img-fluid"
        alt="Slide 4"
        onClick={() => handleZoomIn(image4)}
        style={{ objectFit: "contain", height:'300px',width:'600px',marginTop:'50px',marginBottom:'120px', cursor: 'pointer'}}
      />
      <div className="carousel-caption d-none d-md-block">
        <p style={{ fontSize: '15px', color: '#2e3192' }}>
          Easily automate your content delivery by scheduling posts with precision.
        </p>
      </div>
    </div>

    {/* pending post */}
    <div className="carousel-item">
      <img
        src={image5}
        className="img-fluid"
        alt="Slide 5"
        onClick={() => handleZoomIn(image5)}
        style={{ objectFit: "contain", height:'300px',width:'600px',marginTop:'50px',marginBottom:'120px', cursor: 'pointer'}}

      />
      <div className="carousel-caption d-none d-md-block">
        <p style={{ fontSize: '15px', color: '#2e3192' }}>
          Review, edit, regenerate, Approve AI-crafted posts before they go live.
        </p>
      </div>
    </div>

    {/* knackfeeds */}
    <div className="carousel-item">
      <img
        src={image6}
        className="d-block w-100 img-fluid"
        alt="Slide 6"
        onClick={() => handleZoomIn(image6)}
        style={{ objectFit: "contain", height:'300px',width:'600px',marginTop:'50px',marginBottom:'130px', cursor: 'pointer'}}
      />
      <div className="carousel-caption d-none d-md-block">
        <p style={{ fontSize: '15px', color: '#2e3192' }}>
        Flexible subscription plans for individuals, brands, and agencies - pick what fits your growth!
</p>
      </div>
    </div>

    {/* subscription */}
    <div className="carousel-item">
      <img
        src={image7}
        className="img-fluid"
        alt="Slide 7"
        onClick={() => handleZoomIn(image7)}
        style={{ objectFit: "contain", height:'300px',width:'600px',marginTop:'50px',marginBottom:'130px', cursor: 'pointer'}}

      />
      <div className="carousel-caption d-none d-md-block">
        <p style={{ fontSize: '15px', color: '#2e3192' }}>
        Stay ahead with Knack Feeds—AI-curated LinkedIn posts based on the latest trends, ready to share or customize with a click.      
         </p>
      </div>
    </div>

     {/* linkedinpost*/}
     <div className="carousel-item">
      <img
        src={image8}
        className="img-fluid"
        alt="Slide 8"
        onClick={() => handleZoomIn(image8)}
        style={{ objectFit: "contain", height:'300px',width:'600px',marginTop:'50px',marginBottom:'120px', cursor: 'pointer'}}

      />
      <div className="carousel-caption d-none d-md-block">
        <p style={{ fontSize: '15px', color: '#2e3192' }}>
        Email alert with generated posts on interests and trending topics are sent for user approval        </p>
      </div>
    </div>

    <div className="carousel-item">
      <img
        src={image9}
        className="img-fluid"
        alt="Slide 8"
        onClick={() => handleZoomIn(image9)}
        style={{ objectFit: "contain", height:'300px',width:'600px',marginTop:'50px',marginBottom:'120px', cursor: 'pointer'}}

      />
      <div className="carousel-caption d-none d-md-block">
        <p style={{ fontSize: '15px', color: '#2e3192' }}>
        Post is live on LinkedIn—shared with impact and aligned with your personal interest!
        </p>
      </div>
    </div>
  </div>
  

  {/* Professional Navigation Controls */}
  <div
    className="carousel-control-prev professional-nav-btn"
    type="button"
    data-bs-target="#carouselWithCaptions"
    data-bs-slide="prev"
    style={{ 
      position: "absolute",
      left: "10px", 
      top: "45%", 
      transform: "translateY(-50%)",
      zIndex: 10,
      width: "50px",
      height: "50px",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }}
  >
    <div className="nav-button prev-button">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </div>
    <span className="visually-hidden">Previous</span>
  </div>
  
  <div
    className="carousel-control-next professional-nav-btn"
    type="button"
    data-bs-target="#carouselWithCaptions"
    data-bs-slide="next"
    style={{ 
      position: "absolute",
      right: "10px", 
      top: "45%", 
      transform: "translateY(-50%)",
      zIndex: 10,
      width: "50px",
      height: "50px",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }}
  >
    <div className="nav-button next-button">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </div>
    <span className="visually-hidden">Next</span>
  </div>

</div>

      {/* Zoom Modal */}
      {zoomedImage && (
        <div
          onClick={handleZoomOut}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            animation: 'fadeIn 0.3s ease-in-out'
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: 'relative',
              maxWidth: '90%',
              maxHeight: '90%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              animation: 'zoomIn 0.3s ease-in-out'
            }}
          >
            <img
              src={zoomedImage}
              alt="Zoomed"
              onClick={handleZoomOut}
              style={{
                maxWidth: '100%',
                maxHeight: '90vh',
                objectFit: 'contain',
                borderRadius: '8px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
                cursor: 'pointer'
              }}
            />
            <div
              onClick={handleZoomOut}
              style={{
                position: 'absolute',
                top: '20px',
                right: '20px',
                backgroundColor: '#2e3192',
                borderRadius: '50%',
                width: '50px',
                height: '50px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#1a237e';
                e.currentTarget.style.transform = 'scale(1.1)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#2e3192';
                e.currentTarget.style.transform = 'scale(1)';
              }}
            >
              <FaTimes color="white" size={22} />
            </div>
          </div>
        </div>
      )}

</div>

            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .banner-area.auto-height, .banner-area.auto-height div {
          height: auto;
        }
        
        /* Carousel container positioning */
        #carouselWithCaptions {
          position: relative;
          overflow: visible;
        }
        
        /* Professional Navigation Styling */
        .professional-nav-btn {
          position: absolute;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10;
          background: transparent;
          border: none;
          padding: 0;
        }
        
        .carousel-control-prev,
        .carousel-control-next {
          width: 50px !important;
          height: 50px !important;
        }
        
        .carousel-control-next.professional-nav-btn .nav-button.next-button,
        .carousel-control-prev.professional-nav-btn .nav-button.prev-button {
          width: 50px !important;
          height: 50px !important;
          background: #2e3192;
          border: 1px solid #2e3192;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          transition: all 0.3s ease;
          box-shadow: 0 2px 8px rgba(46, 49, 146, 0.3);
        }
        
        .carousel-control-next.professional-nav-btn .nav-button.next-button:hover,
        .carousel-control-prev.professional-nav-btn .nav-button.prev-button:hover {
          background: #1a237e;
          transform: scale(1.05);
          box-shadow: 0 4px 16px rgba(46, 49, 146, 0.5);
        }
        
        .nav-button {
          width: 50px;
          height: 50px;
          background: #2e3192;
          border: 1px solid #2e3192;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          transition: all 0.3s ease;
          box-shadow: 0 2px 8px rgba(46, 49, 146, 0.3);
          backdrop-filter: blur(10px);
        }
        
        .nav-button svg {
          color: white;
          stroke: white;
        }
        
        .nav-button:hover {
          background: #1a237e;
          color: white;
          transform: scale(1.05);
          box-shadow: 0 4px 16px rgba(46, 49, 146, 0.5);
          border-color: #1a237e;
        }
        
        .nav-button:active {
          transform: scale(0.95);
        }
        
        .nav-button svg {
          transition: all 0.3s ease;
        }
        
        .nav-button:hover svg {
          transform: scale(1.1);
        }
        
        /* Subtle focus states for accessibility */
        .nav-button:focus {
          outline: 2px solid #2e3192;
          outline-offset: 2px;
        }
        
        /* Responsive adjustments */
        @media (max-width: 768px) {
          .nav-button {
            width: 40px;
            height: 40px;
          }
          
          .carousel-control-next.professional-nav-btn .nav-button.next-button,
          .carousel-control-prev.professional-nav-btn .nav-button.prev-button {
            width: 40px !important;
            height: 40px !important;
          }
          
          .nav-button svg {
            width: 16px;
            height: 16px;
          }
          
          .professional-nav-btn {
            width: 40px;
            height: 40px;
          }
          
          .carousel-control-prev {
            left: 5px !important;
          }
          
          .carousel-control-next {
            right: 5px !important;
          }
        }
        
        /* Ensure parent column allows overflow for arrows */
        .col-lg-6.col-sm-12.col-md-6.col-xl-6 {
          overflow: visible;
        }
        
        /* Center carousel content */
        .carousel-item {
          text-align: center;
        }
        
        .carousel-item img {
          margin: 0 auto;
          display: block;
        }
        .banner-area .content {
          padding: 70px 0;
        }
        .banner-area .content h4 {
          margin-bottom: 25px;
        }
        .banner-area .content h2 {
          font-size: 60px;
          margin-bottom: 25px;
        }
        .banner-area .content a {
          margin-top: 20px;
        }
        .banner-area .row.align-center div {
          height: auto;
        }
        .banner-area.inc-shape .thumb {
          position: relative;
          z-index: 1;
        }
        .banner-area .thumb {
          position: relative;
        }
        .elementor img {
          height: auto;
          max-width: 100%;
          border: none;
          border-radius: 0;
          box-shadow: none;
        }
        .banner-area .row.align-center div {
          height: auto;
        }
        .banner-area.inc-shape .thumb {
          position: relative;
          z-index: 1;
        }
        .banner-area.text-color .content h2 strong {
          font-weight: 800;
          color: #2e3192;
        }
        .banner-area .content h2 {
          font-size: 35px;
          margin-bottom: 25px;
        }
        p {
          color: #666;
          margin: 0 0 15px;
          text-transform: none;
          font-weight: 400;
          line-height: 26px;
          font-size: 14px;
        }
        a.btn.circle.btn-theme.effect.btn-md.wow.fadeInUp {
          background-color: #2e3192;
          color: #fff;
          padding: 13px;
          border-radius: 56px;
          font-size: 16px;
          font-weight: bold;
          animation: buttonGlow 2s infinite;
          transition: all 0.3s ease;
          position: relative;
        }
        
        @keyframes buttonGlow {
          0% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(46, 49, 146, 0.7);
          }
          25% {
            transform: scale(1.02);
            box-shadow: 0 0 0 8px rgba(46, 49, 146, 0.3);
          }
          50% {
            transform: scale(1.05);
            box-shadow: 0 0 0 15px rgba(46, 49, 146, 0);
          }
          75% {
            transform: scale(1.02);
            box-shadow: 0 0 0 8px rgba(46, 49, 146, 0.2);
          }
          100% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(46, 49, 146, 0);
          }
        }
        
        /* Additional attention-grabbing effects */
        a.btn.circle.btn-theme.effect.btn-md.wow.fadeInUp::before {
          content: '';
          position: absolute;
          top: -2px;
          left: -2px;
          right: -2px;
          bottom: -2px;
          background: linear-gradient(45deg, #2e3192, #1a237e, #2e3192, #1a237e);
          border-radius: 58px;
          z-index: -1;
          animation: borderGlow 3s infinite;
        }
        
        @keyframes borderGlow {
          0%, 100% {
            opacity: 0.3;
            transform: scale(1);
          }
          50% {
            opacity: 0.8;
            transform: scale(1.02);
          }
        }
        
        /* Text shimmer effect */
        a.btn.circle.btn-theme.effect.btn-md.wow.fadeInUp {
          background: linear-gradient(45deg, #2e3192, #1a237e, #2e3192);
          background-size: 200% 200%;
          animation: buttonGlow 2s infinite, textShimmer 4s infinite;
        }
        
        @keyframes textShimmer {
          0% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
          100% {
            background-position: 0% 50%;
          }
        }
        
        /* Hover effect */
        a.btn.circle.btn-theme.effect.btn-md.wow.fadeInUp:hover {
          background-color: #1a237e;
          transform: scale(1.1);
          box-shadow: 0 8px 25px rgba(46, 49, 146, 0.4);
          animation: none;
        }

        /* Responsive Styles */
        @media (max-width: 992px) {
          .banner-area .content h2 {
            font-size: 50px;
          }
          .banner-area .content p {
            font-size: 16px;
            margin-bottom: 20px;
          }
          .banner-area .content a {
            font-size: 14px;
            padding: 10px 20px;
          }
          .banner-area img {
            height: auto;
            max-width: 90%;
            margin-top: 20px;
          }
        }

        @media (max-width: 768px) {
          .banner-area .content h2 {
            font-size: 40px;
          }
          .banner-area .content p {
            font-size: 14px;
          }
          .banner-area .content a {
            font-size: 13px;
            padding: 10px 18px;
          }
          .banner-area img {
            height: auto;
            max-width: 80%;
            margin-top: 20px;
          }
        }

        @media (max-width: 576px) {
          .banner-area .content h2 {
            font-size: 30px;
          }
          .banner-area .content p {
            font-size: 12px;
          }
          .banner-area .content a {
            font-size: 12px;
            padding: 8px 16px;
          }
          .banner-area img {
            height: auto;
            max-width: 100%;
            margin-top: 10px;
          }
       
@media (max-width: 576px) {
  .banner-area img {
    height: auto;
    max-width: 100%;
    margin-top: 10px !important;
    margin-bottom: 10px !important;
  }

        .carousel-item img {
          margin-top: 10px !important;
          margin-bottom: 10px !important;
        }

        /* Zoom modal styles */
        @keyframes zoomIn {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default Banner;
